// this is an autogenerated file from DesignSystem/AutomationTask/Tags/Content/mutation-update-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_AutomationTask_Tags_Content($id: uuid!, $name: String!) {
  update_tasks_tags_by_pk(pk_columns: { id: $id }, _set: { name: $name }) {
    id
  }
}

`